module.exports = __webpack_public_path__ + "img/homePageImg07.61478daa.png";